export function urlParamsToObject(params) {
  const entries = new URLSearchParams(params).entries()
  const result = {}
  for (const entry of entries) {
    result[entry[0]] = entry[1]
  }
  return result
}

export function objectToUrlParams(param, key, encode) {
  if (param == null) return ''
  let paramStr = ''
  const t = typeof param
  if (t === 'string' || t === 'number' || t === 'boolean') {
    paramStr +=
      '&' + key + '=' + (encode == null || encode ? encodeURIComponent(param) : param)
  } else {
    for (const i in param) {
      const k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i)
      paramStr += objectToUrlParams(param[i], k, encode)
    }
  }
  return paramStr
}

/** Strip leading & from objectToUrlParams output */
export function toQueryString(params) {
  return objectToUrlParams(params).replace(/^&/, '')
}

export function createGUID() {
  const s = []
  const hexDigits = '0123456789abcdef'
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4'
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
  s[8] = s[13] = s[18] = s[23] = '-'
  return s.join('')
}

export function timeQuantum(lastTime, nextTime) {
  const timeDifference = (nextTime || new Date()) - lastTime
  if (timeDifference < 0) return -1
  return Math.ceil(timeDifference / 1000)
}

export function setCookie(cname, cvalue, exdays) {
  const d = new Date()
  d.setTime(d.getTime() + (exdays || 1) * 24 * 60 * 60 * 1000)
  document.cookie = `${cname}=${cvalue}; expires=${d.toUTCString()}; path=/`
}

export function getCookie(cname) {
  const name = `${cname}=`
  const ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1)
    if (c.indexOf(name) !== -1) return c.substring(name.length, c.length)
  }
  return ''
}

export function clearCookie(name) {
  if (name) setCookie(name, '', -1)
}

export function getQueryVariable(variable) {
  const query = window.location.search.substring(1)
  const vars = query.split('&')
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=')
    if (pair[0] === variable) return pair[1]
  }
  return false
}

export function _debounce(fn, time) {
  const delay = time || 500
  let timer
  return function (...args) {
    const that = this
    if (timer) clearTimeout(timer)
    timer = setTimeout(function () {
      timer = null
      fn.apply(that, args)
    }, delay)
  }
}
